import { createApi } from "@reduxjs/toolkit/query/react";
import { queryParams } from "../../../../utils/helper";
import { baseQueryWithAuth } from "../../../BaseQueryWithAuth/baseQueryWithAuth";

export const bmifitnessApiService = createApi({
  reducerPath: "bmifitnessApi",
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    createBMI: builder.mutation({
      query: ({ payload, params }) => {
        const query = queryParams(params);
        return {
          url: `bmifitness/create${query}`,
          method: "POST",
          body: payload,
        };
      },
    }),
    getBMI: builder.query({
      query: (data) => {
        let query = queryParams(data);
        return `bmifitness/get${query}`;
      },
      keepUnusedDataFor: 0,
    }),
    updateBMI: builder.mutation({
      query: ({ id, params, ...payload }) => {
        const query = queryParams(params);
        return {
          url: `bmifitness/${id}${query}`,
          method: "PUT",
          body: payload,
        };
      },
    }),
  }),
});

export const { useCreateBMIMutation, useGetBMIQuery, useUpdateBMIMutation } =
  bmifitnessApiService;
